import { CheckItem } from '@app/models/_index';
import { Factory } from './_factory';
import { FilterCatalogItemService } from '@app/services/_index';
import { Injectable } from '@angular/core';
import { Topic } from '@app/enums/_index';
import { environment } from '@environments/environment';

/**
 * Create Topic Check Item Factory used by application
 * Creates instances of Topic Check Items
 */
@Injectable({
  providedIn: 'root',
})
export class TopicCheckItemFactory implements Factory<CheckItem> {
  topics: CheckItem[] = [];
  isBuilding = false;

  /**
   * Call and build Topic Check Items array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor(private filterCatalogItems: FilterCatalogItemService) {}

  /**
   * Build Topic Check Items array
   */
  async build(): Promise<void> {
    if (!environment.beyond.useDoceboTopics) {
      for (const item in Topic) {
        this.topics.push(new CheckItem(item.toLowerCase(), Topic[item], false, Topic[item], ''));
      }
      return;
    }

    if (this.isBuilding) {
      return;
    }
    this.isBuilding = true;

    // Donot change the param value for getAllObjects function as it is the fieldName of the topics in Docebo
    try {
      const getTopicItems = await this.filterCatalogItems.getAllObjects('Beyond - topic');
      if (getTopicItems && getTopicItems.length > 0) {
        getTopicItems.forEach((allTopics) => {
          if (allTopics && allTopics.value !== Topic.POINTILLIST_CJM) {
            this.topics.push(
              new CheckItem(
                allTopics?.value.toLowerCase().trim(),
                allTopics?.value,
                false,
                `${allTopics?.value} (${allTopics?.count})`,
                ''
              )
            );
          }
        });
      }
    } catch (error) {
      console.error('Error Building topics', error);
    } finally {
      this.isBuilding = false;
    }
  }

  /**
   * Get the collection and build the topics
   * @returns - the copy of the topics
   */
  getCollection(): CheckItem[] {
    if (this.topics && this.topics.length === 0 && !this.isBuilding) {
      this.build();
    }
    return this.topics;
  }
}
